module.exports = __webpack_public_path__ + "img/logo-vector-large.dacbc651.svg";